"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../api/api");
var GetGame = (function () {
    function GetGame() {
        this.api = new api_1.default(window['API_URL'] + '/fast-coin');
    }
    GetGame.prototype.settings = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.api.send('/get-game', {}, function (response) {
                resolve(response);
            }, function (err) {
                console.log('Get game failed.' + JSON.parse(err));
                reject(reject);
            });
        });
    };
    return GetGame;
}());
exports.default = GetGame;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/get-game/get-game.ts
// module id = 2421
// module chunks = 5